<div  class="modal-header">
    <h4 *ngIf="diagramaciones_let.length == 0" class="modal-title" id="mondalAddCampaignTitle">Archivo - {{this.data.fileName}} </h4>
    <h4 *ngIf="diagramaciones_let.length > 0" class="modal-title" id="mondalAddCampaignTitle">Diagramaciones afectadas </h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="modal-body">
      <div class="row">
       <div *ngIf="diagramaciones_let.length > 0" class="col-md-6">

        <div class="row">
         <div class="col-4">
          <p>Modificadas: {{countModificadas()}}/{{diagramaciones_let.length}}</p>
         </div>
         <div class="col d-flex justify-content-end align-items-center" style="padding-top: 8px;">
            <mat-form-field appearance="outline" class="compact-field" style="width: 160px; padding-top: 8px;">
                <mat-label>Lista promociones</mat-label>
                <mat-select [(ngModel)]="selected_promos_masive" multiple class="custom-select-height"
                  (openedChange)="onSelectOpened(true)" (closed)="clearSearch(true)">
                      <mat-option class="search-option-wrapper no-checkbox" [disabled]="true">
                        <div class="search-input-container mat-form-field-outlined">
                          <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
                          <input #searchInputMasive type="text" [(ngModel)]="searchTermMasive"
                            (ngModelChange)="filterPromosMasive()" (click)="$event.stopPropagation()" matInput
                            placeholder="Buscar...">
                        </div>
                      </mat-option>

                      <mat-option class="action-option no-checkbox" (click)="clearAllPromosMasive()" [disabled]="true">
                        <mat-icon>delete_sweep</mat-icon> Quitar todas
                      </mat-option>
                      <mat-option *ngFor="let promo of new_promos" [value]="promo">
                        {{promo}}
                      </mat-option>
                 </mat-select>
            </mat-form-field>
            <button mat-flat-button class="bg-success text-white ms-2" (click)="applyPromosToAll()">Aplicar a seleccionadas<mat-icon>add</mat-icon></button>
          </div>
        </div>

          <div class="col mb-0 table-container">
           <div class="table-wrapper">
            <table mat-table [dataSource]="diagramacionesDataSource"  class="mat-elevation-z8 table table-hover tbl-promo">
              
              <!-- Columnas de texto simple -->
              <ng-container matColumnDef="select">
              <th class="text-center" mat-header-cell *matHeaderCellDef sticky style="min-width: 80px; margin-left: 14px;"> 
                <input type="checkbox" (change)="selectAll($event)">
              </th>
              <td class="text-center" mat-cell sticky *matCellDef="let element" style="min-width: 80px; margin-left: 14px;">
                <div class="checkbox-container">
                  <input type="checkbox" (change)="toggleSelection(element.id)" [checked]="selectedDiagrams.includes(element.id)">
                  <span *ngIf="element.modificado && element.promociones.length > 0" class="modified-indicator" matTooltip="Promociones modificadas">
                    <mat-icon style="font-size: 10px; color: #ffc107;">fiber_manual_record</mat-icon>
                  </span> 
                </div>
              </td>
              </ng-container>
              <ng-container matColumnDef="nombre_proyecto">
                <th mat-header-cell *matHeaderCellDef> Proyecto </th>
                <td mat-cell *matCellDef="let element"> {{element.nombre_proyecto}} </td>
              </ng-container>
              <ng-container matColumnDef="alias">
                <th mat-header-cell *matHeaderCellDef> Alias </th>
                <td mat-cell *matCellDef="let element"> {{element.alias}} </td>
              </ng-container>
              <ng-container matColumnDef="medio">
                <th mat-header-cell *matHeaderCellDef> Medio | POP </th>
                <td mat-cell *matCellDef="let element" class="wrap-text-cell"> {{element.medio}} {{element.pop}}</td>
              </ng-container>
               <ng-container matColumnDef="promociones_faltantes">
                <th mat-header-cell *matHeaderCellDef> Eliminadas </th>
                <td mat-cell *matCellDef="let element">
                  <textarea readonly class="scrollable-textarea">{{ toStringArr(element.promociones_faltantes) }}</textarea>
                </td>
              </ng-container>
              <!-- Columna de Promociones -->
              <ng-container matColumnDef="promociones">
                <th mat-header-cell *matHeaderCellDef> Seleccionadas </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <mat-form-field appearance="outline" class="compact-field">
                    <mat-select [(ngModel)]="element.promociones" (selectionChange)="element.modificado = true" multiple
                      (openedChange)="onSelectOpened(false, i)" (closed)="clearSearch(false, element)">
                      <mat-option class="search-option-wrapper no-checkbox" [disabled]="true">
                        <div class="search-input-container mat-form-field-outlined">
                          <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
                          <input #searchInputRow type="text" [(ngModel)]="element.searchTerm"
                            (ngModelChange)="filterPromosRow(element)" (click)="$event.stopPropagation()" matInput
                            placeholder="Buscar...">
                        </div>
                      </mat-option>

                      <mat-option class="action-option no-checkbox" (click)="clearAllPromosRow(element)" [disabled]="true">
                        <mat-icon>delete_sweep</mat-icon> Quitar todas
                      </mat-option>
                      <mat-option *ngFor="let promo of element.filteredPromos" [value]="promo">
                        {{promo}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
              </ng-container>

              <!-- Columna de Acciones -->
             <!-- <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef> Acciones </th>
                <td mat-cell *matCellDef="let element">
              
                </td>
              </ng-container>-->

              <tr mat-header-row *matHeaderRowDef="diagramacionesColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; let i = index; columns: diagramacionesColumns;"></tr>
            </table>
          </div>
         </div>


       </div>
       <div [ngClass]="diagramaciones_let.length > 0 ? 'col-md-6' : 'col-12'">


        <div class="row">
         <div class="col-4">
          <!--<ng-container *ngIf="diagramaciones_let.length > 0">
              <strong>Hoja seleccionada:</strong><p>{{this.nameSelected}}</p>
          </ng-container>-->
           <ng-container *ngIf="diagramaciones_let.length > 0">
              <strong>Hoja(s) seleccionada(s):</strong><p>{{this.multipleSheetsSelected.toString()}}</p>
          </ng-container>
          <!--<mat-form-field *ngIf="diagramaciones_let.length == 0" appearance="outline" class="compact-field">
              <mat-label>Hoja</mat-label>
              <mat-select [(ngModel)]="this.nameSelected" (selectionChange)="changeSheet($event)">
                  <mat-option *ngFor="let sheet of this.data.sheets" [value]="sheet">{{ sheet }}</mat-option>
              </mat-select>
          </mat-form-field>-->
          <mat-form-field *ngIf="diagramaciones_let.length == 0" appearance="outline" class="compact-field ms-2">
            <mat-label>Hojas seleccionadas</mat-label>
            <mat-select [(ngModel)]="multipleSheetsSelected" multiple>
                <mat-option *ngFor="let sheet of validSheets" [value]="sheet">{{ sheet }}</mat-option>
            </mat-select>
        </mat-form-field>
         </div>

          <div *ngIf="flagCodigo" class="col d-flex justify-content-end">
            <mat-form-field appearance="outline" class="mt-3" style="width: 300px;">
              <mat-label>
                <mat-icon>search</mat-icon>
                Buscar en la hoja
              </mat-label>
              <input matInput (keyup)="applyFilter($event)" placeholder="Escribe para filtrar...">
            </mat-form-field>
          </div>
        </div>

        <label *ngIf="!flagCodigo" class="ms-3 text-danger">No se puede cargar esta hoja ya que no cuenta con la columna CODIGO PRINCIPAL</label>
        <mat-divider></mat-divider>

        <mat-tab-group *ngIf="diagramaciones_let.length == 0" (selectedTabChange)="changeTab(data.sheets[$event.index])" [selectedIndex]="data.sheets.indexOf(tabSelected)">
          <mat-tab *ngFor="let sheet of data.sheets" [label]="sheet">
          </mat-tab>
        </mat-tab-group>


        <div>
            <div class="row g-2">
                <div class="col mb-0 table-container">
                    <div class="table-wrapper">
                        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table table-hover tbl-promo">

            
                          <ng-container *ngFor="let col of columnas" [matColumnDef]="col">
                            <th mat-header-cell *matHeaderCellDef> {{col}} </th>
                            <td mat-cell *matCellDef="let element"> {{element[col]}} </td>
                          </ng-container>

                          <tr mat-header-row *matHeaderRowDef="columnas; sticky: true"></tr>
                          <tr mat-row *matRowDef="let row; columns: columnas;"></tr>

                         
                          <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" [attr.colspan]="columnas.length">No hay datos para mostrar.</td>
                          </tr>
                        </table>
                    </div>
         
                    <mat-paginator [pageSizeOptions]="[50, 100, 250]"
                                   showFirstLastButtons
                                   aria-label="Selecciona la página de resultados">
                    </mat-paginator>
                </div>
            </div>
        </div>
      </div>
      </div>



    </div>
    <div class="modal-footer mt-3">

        <button *ngIf="diagramaciones_let.length > 0" mat-flat-button class="bg-success text-white btnUploadSheet" (click)="validate_promos()" [disabled]="multipleSheetsSelected.length == 0" >Guardar <mat-icon>save</mat-icon></button>

        <button  *ngIf="diagramaciones_let.length == 0" mat-flat-button class="bg-success text-white btnUploadSheet" (click)="uploadSheet()" [disabled]="multipleSheetsSelected.length == 0" >Guardar <mat-icon>save</mat-icon></button>
    </div>
</mat-dialog-content>
